import React from 'react'

const LoadingSpinner = ({ size = 16 }) => {
    const thickness = Math.max(2, Math.round(size / 8))
    return (
        <div style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: '50%',
            background: 'conic-gradient(from 0deg, transparent 0deg, var(--gold-grad-0) 90deg, var(--gold-grad-35) 180deg, var(--gold-grad-55) 300deg, var(--gold-grad-55) 360deg)',
            WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #000 calc(100% - ${thickness}px))`,
            mask: `radial-gradient(farthest-side, transparent calc(100% - ${thickness}px), #000 calc(100% - ${thickness}px))`,
            animation: 'spin 1s linear infinite',
            flexShrink: 0
        }} />
    )
}

export default LoadingSpinner
